import palette from './palette';
import { ITypography } from './types';

const globalTypography = {
  mainFont: '"Open Sans", sans-serif',
  secondaryFont: '"Open Sans", sans-serif',
};

export const typographyScale: ITypography = {
  mainFont: globalTypography.mainFont,
  secondaryFont: globalTypography.secondaryFont,
  fontFamily: globalTypography.secondaryFont,
  fontSize: 18,
  htmlFontSize: 18,
  h1: {
    fontFamily: globalTypography.mainFont,
    fontWeight: 400,
    fontSize: '28px',
    letterSpacing: '-0.24px',
    lineHeight: '40px',
  },
  h2: {
    fontWeight: 700,
    fontSize: '22px',
    letterSpacing: '-0.24px',
    lineHeight: '32px',
  },
  h3: {
    fontWeight: 700,
    fontSize: '18px',
    letterSpacing: '-0.06px',
    lineHeight: '28px',
  },
  h4: {
    fontWeight: 700,
    fontSize: '16px',
    letterSpacing: '-0.06px',
    lineHeight: '24px',
  },
  h5: {
    fontWeight: 700,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  h6: {
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  subtitle1: {
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '25px',
  },
  subtitle2: {
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px',
  },
  body1: {
    fontWeight: 400,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '21px',
  },
  body2: {
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.04px',
    lineHeight: '18px',
  },
  button: {
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  caption: {
    fontSize: '11px',
    letterSpacing: '0.33px',
    lineHeight: '13px',
  },
  overline: {
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
  },
};

const typography: ITypography = {
  ...typographyScale,
  h1: {
    ...typographyScale.h1,
    color: palette.text.primary,
  },
  h2: {
    ...typographyScale.h2,
    color: palette.text.primary,
  },
  h3: {
    ...typographyScale.h3,
    color: palette.text.primary,
  },
  h4: {
    ...typographyScale.h4,
    color: palette.text.primary,
  },
  h5: {
    ...typographyScale.h5,
    color: palette.text.primary,
  },
  h6: {
    ...typographyScale.h6,
    color: palette.text.primary,
  },
  subtitle1: {
    ...typographyScale.subtitle1,
    color: palette.text.primary,
  },
  subtitle2: {
    ...typographyScale.subtitle2,
    color: palette.text.secondary,
  },
  body1: {
    ...typographyScale.body1,
    color: palette.text.primary,
  },
  body2: {
    ...typographyScale.body2,
    color: palette.text.secondary,
  },
  button: {
    ...typographyScale.button,
    color: palette.text.primary,
  },
  caption: {
    ...typographyScale.caption,
    color: palette.text.secondary,
  },
  overline: {
    ...typographyScale.overline,
    color: palette.text.secondary,
  },
};

export default typography;
